export const PatientDashboardModuleRegistry = [
    { id: 101, key: 'patient.health_overview', label: 'Health Overview', scope: 'patient' },
    { id: 102, key: 'patient.lab_results', label: 'Lab Results', scope: 'patient' },
    { id: 103, key: 'patient.lab_trends', label: 'Lab Trends', scope: 'patient' },
    { id: 104, key: 'patient.mylabs_plus', label: 'My Labs Plus', scope: 'patient' },
    { id: 105, key: 'patient.markers_overview', label: 'Markers Overview', scope: 'patient' },
    { id: 106, key: 'patient.recommendations', label: 'Recommendations', scope: 'patient' },
    { id: 107, key: 'patient.wellness_coaching', label: 'Wellness Coaching', scope: 'patient' },
    { id: 108, key: 'patient.health_profile', label: 'Health Profile', scope: 'patient' },
    { id: 109, key: 'patient.latest_order', label: 'Latest Order', scope: 'patient' },
    { id: 110, key: 'patient.points', label: 'Points & Rewards', scope: 'patient' },
];
export const PatientDashboardModules = {
    healthOverview: PatientDashboardModuleRegistry[0].key,
    labResults: PatientDashboardModuleRegistry[1].key,
    labTrends: PatientDashboardModuleRegistry[2].key,
    mylabsPlus: PatientDashboardModuleRegistry[3].key,
    markersOverview: PatientDashboardModuleRegistry[4].key,
    recommendations: PatientDashboardModuleRegistry[5].key,
    wellnessCoaching: PatientDashboardModuleRegistry[6].key,
    healthProfile: PatientDashboardModuleRegistry[7].key,
    latestOrder: PatientDashboardModuleRegistry[8].key,
    points: PatientDashboardModuleRegistry[9].key,
};
export const PatientDashboardModuleIds = {
    [PatientDashboardModules.healthOverview]: 101,
    [PatientDashboardModules.labResults]: 102,
    [PatientDashboardModules.labTrends]: 103,
    [PatientDashboardModules.mylabsPlus]: 104,
    [PatientDashboardModules.markersOverview]: 105,
    [PatientDashboardModules.recommendations]: 106,
    [PatientDashboardModules.wellnessCoaching]: 107,
    [PatientDashboardModules.healthProfile]: 108,
    [PatientDashboardModules.latestOrder]: 109,
    [PatientDashboardModules.points]: 110,
};
export const PatientDashboardModuleLabels = {
    [PatientDashboardModules.healthOverview]: 'Health Overview',
    [PatientDashboardModules.labResults]: 'Lab Results',
    [PatientDashboardModules.labTrends]: 'Lab Trends',
    [PatientDashboardModules.mylabsPlus]: 'My Labs Plus',
    [PatientDashboardModules.markersOverview]: 'Markers Overview',
    [PatientDashboardModules.recommendations]: 'Recommendations',
    [PatientDashboardModules.wellnessCoaching]: 'Wellness Coaching',
    [PatientDashboardModules.healthProfile]: 'Health Profile',
    [PatientDashboardModules.latestOrder]: 'Latest Order',
    [PatientDashboardModules.points]: 'Points & Rewards',
};
export const PatientDashboardModuleKeyById = {
    101: PatientDashboardModules.healthOverview,
    102: PatientDashboardModules.labResults,
    103: PatientDashboardModules.labTrends,
    104: PatientDashboardModules.mylabsPlus,
    105: PatientDashboardModules.markersOverview,
    106: PatientDashboardModules.recommendations,
    107: PatientDashboardModules.wellnessCoaching,
    108: PatientDashboardModules.healthProfile,
    109: PatientDashboardModules.latestOrder,
    110: PatientDashboardModules.points,
};
export const PATIENT_DASHBOARD_MODULE_KEYS = PatientDashboardModuleRegistry.map((module) => module.key);
export const PATIENT_DASHBOARD_MODULE_IDS = PatientDashboardModuleRegistry.map((module) => module.id);
